var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24 44.02C35.0457 44.02 44 35.0657 44 24.02C44 12.9743 35.0457 4.02002 24 4.02002C12.9543 4.02002 4 12.9743 4 24.02C4 35.0657 12.9543 44.02 24 44.02Z",
    fill: "#C9DAE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13.8799C19.86 13.8799 16.5 17.2399 16.5 21.3799C16.5 25.4399 19.68 28.7399 23.9 28.8599C23.96 28.8599 24.04 28.8599 24.08 28.8599C24.12 28.8599 24.18 28.8599 24.22 28.8599C24.24 28.8599 24.26 28.8599 24.26 28.8599C28.3 28.7199 31.48 25.4399 31.5 21.3799C31.5 17.2399 28.14 13.8799 24 13.8799Z",
    fill: "#C9DAE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5599 38.72C33.9999 42 29.2399 44.02 23.9999 44.02C18.7599 44.02 13.9999 42 10.4399 38.72C10.9199 36.9 12.2199 35.24 14.1199 33.96C19.5799 30.32 28.4599 30.32 33.8799 33.96C35.7999 35.24 37.0799 36.9 37.5599 38.72Z",
    fill: "#C9DAE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.e1ccfab8d176d53dc3d7a3ebf702d9d1.svg";
export { ForwardRef as ReactComponent };